export function filterMenu(categories, attributeFilters) {
  if (attributeFilters.length === 0) {
    return categories;
  }

  const result = [];

  categories.forEach((category) => {
    const cat = {
      ...category
    };

    cat.menuItems = cat.menuItems.filter((menuItem) => {
      let doesMatch = true;

      for (let i = 0; i < attributeFilters.length; i++) {
        const filter = attributeFilters[i];

        const attributes = menuItem.attributes || [];
        const attribute = attributes.find(attr => attr.name === filter.name);

        if (filter.isExclusion) {
          doesMatch = !attribute;
        }

        else {
          doesMatch = !!attribute;
        }

        if (!doesMatch) {
          break;
        }
      }

      return doesMatch;
    });

    if (cat.menuItems.length > 0) {
      result.push(cat);
    }
  });

  return result;
}


export function filterExclusiveMenuItems(categories, isEnrolledInLoyalty, isSignedIn) {
  const getFilteredMenuItems = category => category.menuItems.filter((item) => {
    /** If menuItem property 'platformTypes' does not exist, then menuItem is available on all platforms. */
    const isAvailableOnAllPlatforms = !Object.hasOwnProperty.call(item, 'platformTypes');
    /** If 'platformTypes' exists and contains 'Web' entry then menuItem is exclusive to web platform */
    const isWebExclusiveItem = !!item.platformTypes?.some(type => type === 'Web');

    const isLoyaltyExclusiveItem = item.attributes?.find(attribute => attribute.type === 'LoyaltyMemberOnly');

    const isLoggedInExlusiveItem = item.attributes?.find(attribute => attribute.type === 'LoggedInUserOnly');

    if (isLoyaltyExclusiveItem && (isAvailableOnAllPlatforms || isWebExclusiveItem)) return isEnrolledInLoyalty;

    if (isLoggedInExlusiveItem && (isAvailableOnAllPlatforms || isWebExclusiveItem)) return isSignedIn;

    return isAvailableOnAllPlatforms || isWebExclusiveItem;
  });

  const result = [];

  categories.forEach((category) => {
    const menuItems = getFilteredMenuItems(category);

    if (menuItems.length > 0) result.push({ ...category, menuItems });
  });

  return result;
}

export default {
  filterMenu,
  filterExclusiveMenuItems
};

